import FurnishingSelectBlock from "./furnishing-select-block";

import "./furnishing-block.scss";


const FurnishingBlocks = {
    Select : FurnishingSelectBlock
}

export default FurnishingBlocks;